import { TreeNode } from 'primeng/api';
import { FilterTypes } from '../../../models/filterEnums.model';
import { FilterCriteria } from '../shared/filter-criteria.model';

export class AccountTypesCriteria extends FilterCriteria {
  public override title = 'Account Type';
  public override type: FilterTypes = FilterTypes.AccountType;
  accountTypeSelection: TreeNode[] = null;

  public override validate(): boolean {
    return this.accountTypeSelection != null && this.accountTypeSelection.length > 0;
  }

  public override toString(): string {
    const s: string = this.accountTypeSelection ? this.accountTypeSelection.map((selection) => selection.label).join(', ') : '';
    return 'Account Types: ' + s;
  }
}
